import type { ColumnDef } from '@tanstack/vue-table'
import { createBaseColumns, type UserTableActions } from './baseColumns'
import { createDateColumn } from './dateColumns'
import BaseButton from '~/components/BaseButton.vue'
import PenIcon from '~/components/PenIcon.vue'
import TrashGreenIcon from '~/components/TrashGreenIcon.vue'

export const createActiveUsersColumns = (
  actions?: UserTableActions,
): ColumnDef<ManageUserTableRow>[] => {
  const baseColumns = createBaseColumns()
  const dateColumns = [
    createDateColumn('created_at', 'created_at', 'date joined'),
  ]

  const actionsColumn: ColumnDef<ManageUserTableRow> = {
    id: 'actions',
    size: 80,
    header: () => h('span', { class: 'capitalize text-sm text-slate-800 font-semibold' }, 'actions'),
    cell: ({ row }) => {
      const userId = row.original.id
      const tooltipClasses = 'absolute hidden group-hover:block bottom-full left-1/2 transform -translate-x-1/2 px-2 py-1 bg-zuno-primary-2 text-white text-xs rounded whitespace-nowrap mb-1 z-10'

      const handleEdit = () => {
        actions?.onEdit?.(row.original)
      }

      const handleDeactivate = () => {
        actions?.onDeactivate?.(userId)
      }

      return h('div', { class: 'flex' }, [
        h('div', {
          class: 'relative group',
        }, [
          h(BaseButton, {
            variant: 'text',
            onClick: handleEdit,
          }, () => h(PenIcon)),
          h('div', {
            class: tooltipClasses,
          }, 'Edit'),
        ],
        ),
        h('div', {
          class: 'relative group',
        }, [
          h(BaseButton, {
            variant: 'text',
            onClick: handleDeactivate,
          }, () => h(TrashGreenIcon)),
          h('div', {
            class: tooltipClasses,
          }, 'Deactivate'),
        ]),
      ])
    },
  }

  return [
    ...baseColumns,
    ...dateColumns,
    actionsColumn,
  ]
}
